// src/js-dot/data/csv/csv-stringify-from-array.ts
import { getNumbers, isNumber, keyValues } from "@js-dot/core";

// src/js-dot/data/csv/_get-csv-value-string.ts
import { isObject } from "@js-dot/core";
var _ESCAPE = /[\s\t\n\r,]/;
var _DOUBLE_QUOTE = /"/g;
function _getCsvValueString(line, value, unpackConfigure) {
  if (isObject(value)) {
    if (unpackConfigure) {
      const {
        keys,
        length
      } = unpackConfigure;
      let current = length;
      while (current-- > 0) {
        const key = keys[current];
        line[line.length] = key in value ? getValue(value[key]) : "";
      }
    } else {
      line[line.length] = getValue(JSON.stringify(value));
    }
  } else if (unpackConfigure) {
    let {
      length
    } = unpackConfigure;
    while (length-- > 0) {
      line[line.length] = "";
    }
  } else {
    line[line.length] = getValue(value);
  }
}
function getValue(value) {
  switch (typeof value) {
    case "string":
      if (_ESCAPE.test(value)) {
        value = value.replace(_DOUBLE_QUOTE, '\\"');
        return '"' + value + '"';
      }
      break;
    default:
      if (Array.isArray(value)) {
        return '"' + value.join(",") + '"';
      }
  }
  return value;
}

// src/js-dot/data/csv/csv-stringify-from-array.ts
var {
  entries: ENTRIES
} = Object;
function csvStringifyFromArray(items, option = {}) {
  const {
    excludes,
    hasHeader,
    unpacks
  } = option;
  let {
    includes,
    headers
  } = option;
  const first = items[0];
  if (!includes || !includes.length) {
    includes = hasHeader ? first : getNumbers(first.length - 1);
    if (excludes) {
      let excludesCurrent = excludes.length;
      while (excludesCurrent-- > 0) {
        const index = includes.indexOf(excludes[excludesCurrent]);
        if (index > -1) {
          includes.splice(index, 1);
        }
      }
    }
  }
  let indexes = [];
  if (hasHeader) {
    const includesEnd = includes.length;
    let includesCurrent = -1;
    while (++includesCurrent < includesEnd) {
      const include = includes[includesCurrent];
      if (typeof include === "number") {
        indexes[indexes.length] = include;
      } else {
        const index = first.indexOf(include);
        if (index === -1) {
          throw new ReferenceError(`Cannot found header ${include} in first array.`);
        }
        indexes[indexes.length] = index;
      }
    }
    headers = first;
  } else {
    indexes = includes;
    headers = indexes;
  }
  const unpackConfigures = {};
  if (unpacks) {
    for (const [key, configure] of ENTRIES(unpacks)) {
      const index = isNumber(key) ? headers.indexOf(headers[key]) : headers.indexOf(key);
      const unpack = unpacks[key];
      const [keys, values] = keyValues(unpack);
      unpackConfigures[index] = {
        keys: keys.reverse(),
        length: keys.length
      };
      headers.splice(index, 1, ...values);
    }
  }
  const map = option.map || (value => value);
  const lines = [];
  if (hasHeader) {
    lines[0] = (includes ? includes : headers).join(",");
  }
  const end = items.length;
  let current = hasHeader ? 0 : -1;
  const indexEnd = indexes.length;
  while (++current < end) {
    const item = map(items[current]);
    const line = [];
    let indexCurrent = -1;
    while (++indexCurrent < indexEnd) {
      const index = indexes[indexCurrent];
      _getCsvValueString(line, item[index], unpackConfigures[index]);
    }
    lines[lines.length] = line.join(",");
  }
  return lines.join("\n");
}

// src/js-dot/data/csv/csv-stringify-from-object.ts
function csvEncodeFromObject(items, option = {}) {
  const stableOption = {
    unpacks: {},
    includes: [],
    ...(option || {})
  };
  const {
    excludes,
    unpacks,
    useHeader
  } = stableOption;
  let {
    includes
  } = stableOption;
  let end;
  let current = -1;
  const map = option.map || nothingMapFunction;
  end = items.length;
  current = -1;
  const first = items[0];
  if (!includes || !includes.length) {
    if (excludes) {
      let excludesCurrent = excludes.length;
      while (excludesCurrent-- > 0) {
        const exclude = excludes[excludesCurrent];
        if (first.hasOwnProperty(exclude)) {
          delete first[exclude];
        }
      }
    }
    includes = Object.keys(first);
  }
  const headers = [...includes];
  const unpackConfigures = {};
  if (unpacks) {
    const unpackTargets = Object.keys(unpacks);
    current = unpackTargets.length;
    while (current-- > 0) {
      const unpackTarget = unpackTargets[current];
      const headerIndex = headers.indexOf(unpackTarget);
      if (headerIndex > -1) {
        const unpack = unpacks[unpackTarget];
        const unpackProperties = Object.keys(unpack);
        unpackConfigures[unpackTarget] = {
          properties: unpackProperties.reverse(),
          length: unpackProperties.length
        };
        headers.splice(headerIndex, 1, ...Object.values(unpack));
      }
    }
  }
  const includeEnd = headers.length;
  let includeCurrent;
  const lines = [];
  if (useHeader !== false) {
    lines[0] = headers.join(",");
  }
  const _escapes = /[\s\t\n\r,]/;
  const _doubleQuote = /"/g;
  while (++current < end) {
    const item = map(items[current]);
    const line = [];
    includeCurrent = -1;
    while (++includeCurrent < includeEnd) {
      const include = includes[includeCurrent];
      let value = item[include];
      const type = typeof value;
      const unpack = unpacks[include];
      if (type === "object" && value !== null && value !== void 0 && !Array.isArray(type) || unpack) {
        if (!unpack) {
          continue;
        }
        if (!value) {
          value = {};
        }
        const {
          properties,
          length
        } = unpackConfigures[include];
        let unpackCurrent = length;
        while (unpackCurrent-- > 0) {
          line[line.length] = value[properties[unpackCurrent]] || "";
        }
        continue;
      }
      switch (type) {
        case "string":
          if (_escapes.test(value)) {
            value = value.replace(_doubleQuote, '\\"');
            value = '"' + value + '"';
          }
          break;
        default:
          if (Array.isArray(value)) {
            value = '"' + value.join(",") + '"';
          }
      }
      line[line.length] = value;
    }
    lines.push(line.join(","));
  }
  return lines.join("\n");
}
function nothingMapFunction(item) {
  return item;
}

// src/js-dot/data/csv/csv.ts
import { casting } from "@js-dot/core";
var CSV = class {
  static parse(csvString) {
    const rows = [];
    const end = csvString.length;
    let current = -1;
    let char;
    let row = [];
    let cell = "";
    while (++current < end) {
      char = csvString.charAt(current);
      switch (char) {
        case '"':
          dq: while (++current < end) {
            char = csvString.charAt(current);
            switch (char) {
              case '"':
                break dq;
              case "\\":
                if (csvString.charAt(current + 1) === '"') {
                  current++;
                  cell += '"';
                  break;
                }
              default:
                cell += char;
            }
          }
          break;
        case "\r":
          break;
        case "\n":
          row.push(casting(cell.trim()));
          cell = "";
          rows.push(row);
          row = [];
          break;
        case ",":
          row.push(casting(cell.trim()));
          cell = "";
          break;
        default:
          cell += char;
      }
    }
    if (cell) {
      row.push(cell.trim());
    }
    if (row.length) {
      rows.push(row);
    }
    return rows;
  }
  static stringify(items, option = {}) {
    const first = items[0];
    if (typeof first === "object") {
      return csvEncodeFromObject(items, option);
    }
    if (Array.isArray(items)) {
      return csvStringifyFromArray(items, option);
    }
    throw new Error("Not Implemented");
  }
};
export { CSV, csvEncodeFromObject, csvStringifyFromArray };
